/**
 * assets/footer.js (16-10-2026)
 * Gedrag van sections/footer.liquid. Uitleg: docs/footer.md.
 *
 * - De drie linkgroepen (Assortiment, Hulp en voordeel, Klantenservice) zijn <details>. In de HTML
 *   staan ze open, zodat alles zonder JavaScript zichtbaar en crawlbaar is. Op mobiel (onder 1024 px)
 *   klappen ze dicht; op desktop blijven ze open en is de kop geen knop.
 * - Klikmeting: data-footer-klik gaat als GA4-event footer_klik mee (groep en link).
 */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 1023px)');

  function zet() {
    var groepen = document.querySelectorAll('[data-footer-groep]');
    for (var i = 0; i < groepen.length; i++) {
      if (mq.matches) groepen[i].removeAttribute('open');
      else groepen[i].setAttribute('open', '');
    }
  }

  zet();
  if (mq.addEventListener) mq.addEventListener('change', zet);
  else if (mq.addListener) mq.addListener(zet);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var kop = e.target.closest('[data-footer-groep] > summary');
    if (kop && !mq.matches) e.preventDefault();
    var a = e.target.closest('[data-footer-klik]');
    if (a && typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'footer_klik', {
          groep: a.getAttribute('data-footer-klik'),
          link: a.getAttribute('href') || (a.textContent || '').trim().slice(0, 60)
        });
      } catch (err) {}
    }
  });
})();
